export enum CpwUserPositionTypes {
    Receiving = 'Receiving',
    Picking = 'Picking',
    Packing = 'Packing',
    Replenishments = 'Replenishments',
    CycleCounts = 'CycleCounts',
    Exceptions = 'Exceptions',
    Putaway = 'PutAway',
}
